export const Navigation = (props) => {

  function changeLanguage() {
    props.language(document.getElementById('language-picker-select').value);
  }

  return (
    <nav id='menu' className='navbar navbar-default navbar-fixed-top'>
      <div className='container'>
        <div className='navbar-header'>
          <button
            type='button'
            className='navbar-toggle collapsed'
            data-toggle='collapse'
            data-target='#bs-example-navbar-collapse-1'
          >
            {' '}
            <span className='sr-only'>Toggle navigation</span>{' '}
            <span className='icon-bar'></span>{' '}
            <span className='icon-bar'></span>{' '}
            <span className='icon-bar'></span>{' '}
          </button>
          <a className='navbar-brand page-scroll' href='#page-top'>
            <img src="img/logo.png" className="img-responsive brand" alt="" />{" "}
          </a>{' '}
        </div>

        <div
          className='collapse navbar-collapse'
          id='bs-example-navbar-collapse-1'
        >
          <ul className='nav navbar-nav navbar-right'>
            {/* <li>
              <a href='#features' className='page-scroll'>
                Features
              </a>
            </li> */}
            <li>
              <a href='#about' className='page-scroll'>
                {props.data ? props.data.About : 'Loading'}
              </a>
            </li>
            <li>
              <a href='#services' className='page-scroll'>
              {props.data ? props.data.Services : 'Loading'}
              </a>
            </li>
            <li>
              <a href='#portfolio' className='page-scroll'>
              {props.data ? props.data.Gallery : 'Loading'}
              </a>
            </li>
            <li>
              <a href='#testimonials' className='page-scroll'>
              {props.data ? props.data.Testimonials : 'Loading'}
              </a>
            </li>
            <li>
              <a href='#contact' className='page-scroll'>
              {props.data ? props.data.Contact : 'Loading'}
              </a>
            </li>
            <li>
              <select name="language-picker-select" id="language-picker-select" className="language-picker" onChange={changeLanguage}>
                <option value="pl">Polski</option>
                <option value="en">English</option>
                <option value="de">Deutsch</option>
              </select>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  )
}
